import { Helmet } from "react-helmet-async";

const SITE_NAME = "Hylas Companion Trucking";
const BASE_URL = "https://hylascompanion.com";
// Default OG/Twitter share image — highway aerial (1264×848)
const DEFAULT_OG_IMAGE = "https://static.prod-images.emergentagent.com/jobs/6574159f-288e-4b5c-b16a-0836ebfc6103/images/1dc4c9708d3db53c1744d14de995b233c33d2ac441d05e3cab865cfa97e01c20.jpeg";

export default function SEOHead({
  title,
  description,
  keywords,
  path = "/",
  schema = null,
  noindex = false,
  ogImage = null,
}) {
  const pageTitle = title
    ? `${title} | ${SITE_NAME}`
    : `${SITE_NAME} | OTR Truck Driver Jobs | CDL-A Hiring Nationwide`;
  const canonicalUrl = `${BASE_URL}${path}`;
  const shareImage = ogImage || DEFAULT_OG_IMAGE;

  return (
    <Helmet>
      <title>{pageTitle}</title>
      <meta name="description" content={description} />
      {keywords && <meta name="keywords" content={keywords} />}
      <link rel="canonical" href={canonicalUrl} />
      {noindex
        ? <meta name="robots" content="noindex,nofollow" />
        : <meta name="robots" content="index,follow,max-snippet:-1,max-image-preview:large,max-video-preview:-1" />
      }

      {/* Open Graph */}
      <meta property="og:type" content="website" />
      <meta property="og:site_name" content={SITE_NAME} />
      <meta property="og:url" content={canonicalUrl} />
      <meta property="og:title" content={pageTitle} />
      <meta property="og:description" content={description} />
      <meta property="og:image" content={shareImage} />
      <meta property="og:image:width" content="1264" />
      <meta property="og:image:height" content="848" />
      <meta property="og:locale" content="en_US" />

      {/* Twitter Card — large image for rich previews */}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={pageTitle} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:image" content={shareImage} />

      {/* JSON-LD Structured Data */}
      {schema && (
        <script type="application/ld+json">
          {JSON.stringify(schema)}
        </script>
      )}
    </Helmet>
  );
}
